export default __webpack_public_path__ + "img/sidebar_outreach.0e5fa5c0.svg";